import React from 'react';

import CardText from 'components/Card/Text';
import TermsOfService from 'components/TermsOfService';

const styles = {
  terms: {
    overflowY: 'scroll',
    border: '1px solid #ccc',
    padding: 10,
    height: 250,
  },
};

export default props => (
  <CardText noTopPadding {...props}>
    <TermsOfService style={styles.terms} />
  </CardText>
);
